<h1 mat-dialog-title>
    {{documentTypeName}} erstellen
</h1>
<p *ngIf="supplierName">{{supplierLabel$ | async }}: <strong>{{supplierName}}</strong></p>
<p *ngIf="commissionName">{{commissionLabel$ | async}}: <strong>{{commissionName}}</strong></p>

<label id="price-type-radio-group-label">Preis auswählen:</label>
<mat-radio-group
    aria-labelledby="price-type-radio-group-label"
    [(ngModel)]="priceType">
    <mat-radio-button [value]="NewOrderConfirmDialogPriceType.costFromArl">
        EK beibehalten
    </mat-radio-button>
    <mat-radio-button [value]="NewOrderConfirmDialogPriceType.costFromM2s">
        EK aus den Stammdaten übernehmen
    </mat-radio-button>
</mat-radio-group>
<mat-dialog-actions>
    <button app-button Color="cancel" Inverted [mat-dialog-close]="">Abbrechen</button>
    <button app-button Color="green" [mat-dialog-close]="priceType">{{documentTypeName}} erzeugen</button>
</mat-dialog-actions>
